import React, { useEffect, useState } from 'react';
import ConnectionListView from './ConnectionListView';
import ConnectionDetailView from './ConnectionDetailView';
import SetupWizard from './SetupWizard';
import { PmsConnection, getHostexConnection } from '../../api.channelManager';
import './channelManager.css';

type View = 'list' | 'wizard' | 'detail';

/**
 * Account-level Hostex connection: a guided setup wizard for first-time connect, then a one-row
 * list that opens into an Info/Messages detail view. Replaces the single card that used to pack
 * the token field, webhook status, setup guide and message editor into one scroll.
 */
const ChannelManagerHub: React.FC = () => {
  const [connection, setConnection] = useState<PmsConnection | null>(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState<View>('list');

  const load = async () => {
    setLoading(true);
    try {
      const conn = await getHostexConnection();
      setConnection(conn);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleWizardDone = (conn: PmsConnection) => {
    setConnection(conn);
    setView('list');
  };

  if (loading) {
    return <div style={{ color: '#718096', fontSize: '0.9rem' }}>…</div>;
  }

  return (
    <div>
      {view === 'list' && (
        <ConnectionListView
          connection={connection}
          onAdd={() => setView('wizard')}
          onOpen={() => setView('detail')}
        />
      )}

      {view === 'wizard' && <SetupWizard onCancel={() => setView('list')} onDone={handleWizardDone} />}

      {view === 'detail' && connection && connection.connected && (
        <ConnectionDetailView
          connection={connection}
          onBack={() => setView('list')}
          onChanged={setConnection}
          onDisconnect={() => {
            setConnection(null);
            setView('list');
          }}
        />
      )}
    </div>
  );
};

export default ChannelManagerHub;
